import React, {useContext, useState, useRef, useEffect} from 'react';
import {TemplateNameRibbon, SequenceStages} from "@exceed.ai/exceed-utils"
import {AppStoreContext} from "components/Mall/AppStore/AppStore";
import {ExceedApiContext} from "containers/App/ExceedApi";
import "./Task.css";
import TimeAgo from 'javascript-time-ago';
import ActivityLog from 'components/ActivityLog/ActivityLog'
import 'rmc-tabs/assets/index.css';
import BackButton from 'components/BackButton'
import EditResponse from './EditResponse'

// English.
import en from 'javascript-time-ago/locale/en';
import {Button, CarouselItem, Icon,} from 'react-onsenui';
import {notification} from 'onsenui';
import {Tabs, DefaultTabBar} from "rmc-tabs";
import {useHistory} from "react-router";
import EmptyToolbar from "components/EmptyToolbar";

const {findTemplateByName, templateTypes} = SequenceStages
const ASSIGNED_REP_EMAIL_PLACEHOLDER = 'assigndRep@exceed.ai';

TimeAgo.addDefaultLocale(en);
const timeAgo = new TimeAgo('en-US');

// eslint-disable-next-line import/no-anonymous-default-export
export default ({task, index, navigator}) => {
    const ExceedApi = useContext(ExceedApiContext);
    const AppStore = useContext(AppStoreContext);

    const editorRef = useRef(null)
    const [content, setContent] = useState(task.message.threadTopMessageHtml)
    const [userItem, setUserItem] = useState(undefined);
    const [playbookTemplates, setPlaybookTemplates] = useState(undefined);
    const [templateToApprove, setTemplateToApprove] = useState({
        text: task.message.text,
        subject: task.message.subject,
        sendingOption: task.message.sendingOption,
        attachments: task.message.attachments,
        originatedFromTemplateId: task.message.originatedFromTemplateId,
        templateType: task.message.templateType
    });
    const [taskMode, setTaskMode] = useState(0);

    useEffect(() => {
        ExceedApi.getLeadDetails(AppStore.getSelectedBot.id, task.userId)
            .then((userItem) => setUserItem(userItem));

        const fetchTemplates = async () => {
            const playbookTemplates = await ExceedApi.getPlaybookTemplates(AppStore.getSelectedBot.id,
                task.playbookInfo ? task.playbookInfo.playbookId : task.playbookId,
                (task.senderPlatform === "EMAIL" ? "EMAIL" : "MOBILE"));
            setPlaybookTemplates(playbookTemplates.emailTemplates);
        }

        fetchTemplates();

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    let history = useHistory();

    let contactName = undefined;
    if (task.message.to) {
        contactName = task.message.to[0].personal ? task.message.to[0].personal : (task.message.to[0].address.indexOf("@") !== -1 && task.message.to[0].address.split("@")[0]);
    } else if (task.message.toNumber && task.message.toName) {
        contactName = task.message.toName;
    }

    const selectDifferentTemplate = async (selectedTemplate) => {
        const isEmailAction = task.senderPlatform === "EMAIL";
        const senderPlatform = isEmailAction ? "EMAIL" : "MOBILE";
        let variants = playbookTemplates[selectedTemplate]["0"]?.default?.flat() || [];

        if (variants.length > 0) {
            let selected = variants[0];

            if (variants.length > 1) {
                let randIndex = Math.floor(Math.random() * Math.floor(variants.length));
                selected = variants[randIndex];
            }

            let templateText = selected.template.text;
            let templateId = selected.template.id;
            let templateSubject = selected.template.subject;
            let attachments = selected.template.attachments;
            let sendingOption = selected.template.sendingOption;

            const originalTemplate = task.originalMessage.templateName;
            const previousTemplate = task.message.templateName;
            const clearHold = originalTemplate === templateTypes.CONTACT_ME_LATER_APPROVE.name && selectedTemplate !== templateTypes.CONTACT_ME_LATER_APPROVE.name;

            if (isEmailAction) {
                const isOriginalCc = findTemplateByName(originalTemplate)?.ccAssignedRep;
                const isPreviousCc = findTemplateByName(previousTemplate)?.ccAssignedRep;
                const selectedTemplateData = findTemplateByName(selectedTemplate);
                const isSelectedCc = selectedTemplateData?.ccAssignedRep;

                if ((isOriginalCc || isPreviousCc) && !isSelectedCc) {
                    // this.emailStructureCard.current.handleCcChange([]);
                } else if ((!isOriginalCc || !isPreviousCc) && isSelectedCc) {
                    const assignedRepId = userItem.leadInfo.assignedRepId;
                    // const assignToAdmins = await this.props.apiRest.getAdminsToAssign(this.props.appStore.getSelectedBotId, this.props.userItem.activePlaybookInfo.playbookId);
                    const assignToAdmins = [];
                    const assignedRepEntity = assignToAdmins.find(x => x.id === assignedRepId);

                    //TODO : handle CC
                    if (assignedRepEntity) {
                        // this.state.cc.push(assignedRepEntity.username);
                        // this.emailStructureCard.current.handleCcChange(_.uniq(this.state.cc));
                    }
                }


                if (selectedTemplateData?.addThreadCCs && task.originalMessage.cc?.length > 0) {
                    //TODO : handle CC
                    // task.originalMessage.cc.filter(originalCc => originalCc.address).forEach(originalCc => this.state.cc.push(originalCc.address));
                    // this.emailStructureCard.current.handleCcChange(_.uniq(this.state.cc));
                }
            }

            setContent(templateText);
            setTemplateToApprove({
                text: templateText,
                subject: templateSubject,
                sendingOption,
                attachments,
                originatedFromTemplateId: templateId,
                clearHold,
                templateType: selected.template.type,
                templateName: selected.template.type, // how come?
            });

            // This is a call back, called after user selected template and need to move to EditResponse view.
            await navigator.replacePage({
                title: task.id,
                backButton: <BackButton navigator={navigator} text={"Cancel"}/>,
                rightButton: <div className="text-primary"
                                  onClick={() => approveClicked(templateToApprove, content)}>Done</div>,
                Component: () => <EditResponse navigator={navigator} content={templateText} setContent={setContent}
                                               editorRef={editorRef} templateToApprove={{
                    text: templateText,
                    subject: templateSubject,
                    sendingOption,
                    attachments,
                    originatedFromTemplateId: templateId,
                    clearHold,
                    templateType: selected.template.type,
                    templateName: selected.template.type, // how come?
                }} approveClicked={approveClicked}
                                               senderPlatform={task.senderPlatform}
                                               userItem={userItem} selectDifferentTemplate={selectDifferentTemplate}/>
            });

        } else {
            console.error(`Cannot find selected template (${selectedTemplate}) of type ${senderPlatform} in sequenceId=(${task.playbookInfo.playbookId})`)
        }
    }

    const calculateStatus = (newTemplateType) => {
        let leadStatus = null;
        let statusReason = null;
        let statusReasonDetails = null;

        if (newTemplateType === "Default Email") {
            leadStatus = "Engaged";
        }

        if (task.originalMessage.templateName !== newTemplateType) {
            if (newTemplateType === "Rep Handover Qualified" || newTemplateType === "Meeting Time Not Free") {
                leadStatus = "Assigned To Rep";
            } else if (newTemplateType === "Call Me") {
                leadStatus = "Assigned To Rep";
                statusReason = "Call Requested";
            } else if (newTemplateType === "Engaged" || newTemplateType === "Contact Me Later Approve") {
                leadStatus = "Engaged";
            } else if (newTemplateType === "Lead Opted Out") {
                leadStatus = "Ended";
                statusReason = "Opt Out";
                statusReasonDetails = "Opted out";
            } else if (newTemplateType === "Lead Not Fit") {
                leadStatus = "Ended";
                statusReason = "Disqualified";
                statusReasonDetails = "Not a good fit";
            } else if (newTemplateType === "Not Interested") {
                leadStatus = "Ended";
                statusReason = "Disqualified";
                statusReasonDetails = "Not Interested";
            } else if (newTemplateType === "Wrong Person") {
                leadStatus = "Ended";
                statusReason = "Wrong Person";
            } else if (newTemplateType === "Existing Customer") {
                leadStatus = "Ended";
                statusReason = "Disqualified";
                statusReasonDetails = "Existing customer";
            } else if (newTemplateType === "Existing Prospect") {
                leadStatus = "Ended";
                statusReason = "Disqualified";
                statusReasonDetails = "Existing prospect";
            }
        } else {
            // Return the original status, in case there is no change template action
            return {
                "leadStatus": task?.leadStatusInfo?.leadStatus,
                "statusReason": task?.leadStatusInfo?.statusReason,
                "statusReasonDetails": task?.leadStatusInfo?.statusReasonDetails

            };
        }

        return {leadStatus, statusReason, statusReasonDetails}
    }

    const handleApprove = async (approved, templateToApprove, newContent) => {
        // approve + template
        if (approved) {
            let response = calculateStatus.call(this, templateToApprove.templateName);
            let cc = [];

            Object.keys(templateTypes).forEach(template => {
                if (templateTypes[template].name === templateToApprove?.templateName && templateTypes[template].ccAssignedRep) {
                    cc.push(ASSIGNED_REP_EMAIL_PLACEHOLDER);
                }
            })

            await ExceedApi.approveMessage(
                task.id,
                AppStore.getSelectedBot.id,
                AppStore.getSessionData.agentId,
                newContent,
                templateToApprove.subject,
                false,
                cc,
                response.leadStatus,
                undefined, //this.state.selectedIntents,
                response.statusReason,
                response.statusReasonDetails,
                templateToApprove.templateName,
                templateToApprove.templateType,
                templateToApprove.attachments,
                templateToApprove.originatedFromTemplateId,
                undefined, //this.state.editDetails,
                templateToApprove.clearLeadHold,
                undefined, //this.props.tasksStore.getSelectedAction.leadHoldInfo,
                templateToApprove.sendingOption
            );

            // can be a better solution here
            history.push('/');
            let leadAddress = task.message.to?.[0].address || task.message.toNumber;
            console.log(`The response will be sent out to ${leadAddress || "contact"}`);

            // approve no-op
        } else {
            // let statusResult = calculateStatus.call(this, this.props.tasksStore.getSelectedAction.message.templateName);
            // let leadStatusModel = {
            //     "leadStatusEnum": statusResult.leadStatus,
            //     "statusReason": statusResult.statusReason,
            //     "statusReasonDetails": statusResult.statusReasonDetails
            // };
            //
            // await this.props.apiRest.approveNoopMessage(this.props.tasksStore.getSelectedAction.id, this.props.appStore.getSelectedBotId, this.props.appStore.getUserId, leadStatusModel,
            //     this.props.tasksStore.getSelectedAction.clearLeadHold ? null : this.props.tasksStore.getSelectedAction.leadHoldInfo);
            //
            // if (this.props.landlordApproval) {
            //     message.success(`The contact will be moved to tasks list.`);
            // } else {
            //     message.success(`The contact was updated successfully`);
            // }
        }
    }

    const approveClicked = (templateToApprove, content) => notification.confirm({
        message: "You are about to approve sending a response to the contact.",
        title: "Are you sure?",
        callback: (approved) => handleApprove(approved, templateToApprove, content)
    });

    const isEscalationTask = task.message.templateType === "Default Email";

    const editTemplate = async () => {
        await navigator.pushPage({
            title: task.id,
            backButton: <BackButton navigator={navigator} text={"Cancel"}/>,
            rightButton: <div className="text-primary"
                              onClick={() => approveClicked(templateToApprove, content)}>Done</div>,
            Component: () => <EditResponse navigator={navigator} content={content} setContent={setContent}
                                           editorRef={editorRef} templateToApprove={templateToApprove}
                                           senderPlatform={task.senderPlatform} approveClicked={approveClicked}
                                           userItem={userItem} selectDifferentTemplate={selectDifferentTemplate}/>
        });
    }

    const backButtonAction = () => history.push("/");

    return <CarouselItem key={task.id}
        // style={{display: "flex", flexDirection: "column", height: "100%"}}
    >
        <EmptyToolbar left={<BackButton navigator={navigator} text={`All tasks`} custom={backButtonAction}/>}/>

        <div className="exceed_page">
            <Tabs tabs={[
                {key: '0', title: 'Task Details'},
                {key: '1', title: 'Previous Interaction'}
            ]} page={taskMode}
                  onChange={(tab, index) => {
                      console.log('onChange', tab, index);
                      setTaskMode(index)
                  }}
                  renderTabBar={(props) => <DefaultTabBar
                      {...props}
                      renderTab={(tab) => {
                          return <div id="tab">{tab.title}</div>;
                      }}
                  />}
            >

                {
                    taskMode === 1 ? (<ActivityLog key={task.id} userId={task.userId}/>) :
                        (
                            <div style={{
                                flex: "1",
                                display: "flex",
                                flexDirection: "column",
                                overflowY: "scroll",
                                padding: "10px"
                            }}>

                                <div id={"task_timestamp"} style={{display: "flex", justifyContent: "flex-end"}}
                                     className="task_header">
                                    {timeAgo.format(new Date(task.scheduledTimestamp))}
                                </div>

                                <div id={"task_contact_details"} style={{display: "flex"}}>
                                    <div className="circle">
                                        <span className="initials">{contactName[0]}</span>
                                    </div>
                                    <div className="task_value"
                                         style={{
                                             display: "flex",
                                             flexDirection: "column",
                                             justifyContent: "space-around",
                                             paddingLeft: "10px"
                                         }}>
                                        <div>{contactName}</div>
                                        <div style={{color: "#888888"}}>
                                            {
                                                task.senderPlatform === "EMAIL" ? (task.message.to[0].address) : (task.message.toNumber)
                                            }
                                        </div>
                                    </div>
                                </div>

                                <hr/>

                                <div id={"task_sequence_details"}>
                                    <p className="task_header">Sequence</p>
                                    <div className="task_value">{task.playbookInfo.playbookName}</div>
                                </div>

                                <hr/>

                                <div id={"task_contact_reply"}>
                                    <p className="task_header">Contact's Reply</p>
                                    <blockquote>
                                        <p>{task.triggeredInboundTextShorten ? task.triggeredInboundTextShorten : " "}</p>
                                    </blockquote>
                                </div>

                                <hr/>

                                <div id={"task_suggestedResponse"}>
                                    <p className="task_header">Suggested Response</p>
                                    <div className="task_value flex_row"
                                         style={{justifyContent: "space-between"}}
                                         onClick={editTemplate}>
                                        {!isEscalationTask ? <TemplateNameRibbon
                                            templateName={templateToApprove.templateType}/> : ("None suggested")}
                                        <Icon
                                            style={{color: "#a09e9e"}}
                                            size={{default: 32}}
                                            icon={{default: 'chevron-right'}}
                                        />
                                    </div>
                                </div>

                                <hr/>

                                <div id={"task_cta"} className="flex-col flex-1"
                                     style={{justifyContent: "flex-end"}}>
                                    {
                                        isEscalationTask ? undefined : (
                                            <div style={{paddingBottom: "10px"}}>
                                                <Button modifier="large" onClick={approveClicked}>Approve</Button>
                                            </div>)
                                    }
                                </div>
                            </div>
                        )
                }
            </Tabs>
        </div>
    </CarouselItem>
}